import commonStyles from "./common";

const styles = {
  fullWidthTableColumn: {
    ...commonStyles.tableCol,
    ...commonStyles.width100
  },
  tableWithMarginTop: {
    ...commonStyles.table,
    ...commonStyles.marginTop20
  },
  tableHeader: {
    ...commonStyles.tableCell,
    fontWeight: "medium"
  },
  tableHeaderWithoutAutoMargin: {
    ...commonStyles.tableCellWithoutAutoMargin,
    fontWeight: "medium"
  },
  titleValue: {
    ...commonStyles.tableCol,
    width: "32%"
  },
  familyBackgroundDetails: {
    ...commonStyles.tableCol,
    width: "80%"
  },
  familyMemberHeaderName: {
    ...commonStyles.tableCell,
    fontWeight: "medium",
    textAlign: "center",
    width: "29.8%"
  },
  familyMemberHeaderOccupation: {
    ...commonStyles.tableCell,
    fontWeight: "medium",
    textAlign: "center",
    width: "23.5%"
  },
  profileHeading: {
    fontSize: 14
  },
  firstNameKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  firstNameValue: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  middleNameKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  middleNameValue: {
    ...commonStyles.tableCol,
    width: "17%"
  },
  nameKey: {
    ...commonStyles.tableCol,
    width: "14%"
  },
  nameValue: {
    ...commonStyles.tableCol,
    width: "19%"
  },
  dateOfBirthKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  dojValue: {
    ...commonStyles.tableCol,
    width: "36%"
  },
  dateOfBirthValue: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  genderKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  genderValue: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  businessTitleValue: {
    ...commonStyles.tableCol,
    width: "17%"
  },
  maritalStatusKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  maritalStatusValue: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  spouseNameKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  spouseNameValue: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  marriageDateKey: {
    ...commonStyles.tableCol,
    width: "19%"
  },
  marriageDateValue: {
    ...commonStyles.tableCol,
    width: "17%"
  },
  panCardKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  panCardValue: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  aadhaarKey: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  aadhaarValue: {
    ...commonStyles.tableCol,
    width: "16%"
  },
  personalMailKey: {
    ...commonStyles.tableCol,
    width: "19%"
  },
  personalMailValue: {
    ...commonStyles.tableCol,
    width: "17%"
  },
  addressLineKey: {
    ...commonStyles.tableCol,
    width: "15%"
  },
  addressLineValue: {
    ...commonStyles.tableCol,
    width: "85%"
  },
  halfQuarterWidthCol: {
    ...commonStyles.tableCol,
    width: "12.5%"
  },
  phoneKey: {
    ...commonStyles.tableCol,
    width: "28%"
  },
  phoneValue: {
    ...commonStyles.tableCol,
    width: "22%"
  },
  contactNameKey: {
    ...commonStyles.tableCol,
    width: "20%"
  },
  contactNameValue: {
    ...commonStyles.tableCol,
    width: "30%"
  },
  employeeRelationKey: {
    ...commonStyles.tableCol,
    width: "25%"
  },
  employeeRelationValue: {
    ...commonStyles.tableCol,
    width: "25%"
  },
  totalExperienceKey: {
    ...commonStyles.tableCol,
    width: "35%"
  },
  inYearsStyles: {
    ...commonStyles.tableCol,
    width: "12%"
  },
  totalExperienceValue: {
    ...commonStyles.tableCol,
    width: "53%"
  },
  lastExperienceTitle: {
    ...commonStyles.tableCol,
    width: "35%"
  },
  lastNameValue: {
    ...commonStyles.tableCol,
    width: "17%"
  },
  fromDate: {
    ...commonStyles.tableCol,
    width: "12%"
  },
  toDate: {
    ...commonStyles.tableCol,
    width: "12%"
  },
  designation: {
    ...commonStyles.tableCol,
    width: "21%"
  },
  grossPay: {
    ...commonStyles.tableCol,
    width: "20%"
  },
  declarationNameAndSignature: {
    ...commonStyles.tableCol,
    width: "50%",
    display: "flex",
    flexDirection: "column"
  },
  declarationName: {
    ...commonStyles.tableCol,
    width: "100%",
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  declarationSignature: {
    ...commonStyles.tableCol,
    width: "100%",
    borderRightWidth: 0,
    textAlign: "left"
  },
  serialNumberCol: { width: "8%" },
  nameAndAddressCol: { width: "45%" },
  ageOfNomineeCol: { width: "10%" },
  relationShipCol: { width: "17%" },
  detailsKeyColumn: { width: "32%" },
  formFDetails: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-around",
    height: 260,
    marginLeft: 5
  },
  dependantPoint: { marginLeft: 11, marginTop: 5 },
  thanaOrDistrict: { width: "8%" },
  villageOrPostOffice: { width: "14%" },
  tableColWidth13: {
    ...commonStyles.tableCol,
    width: "13%"
  },
  tableColWidth16: {
    ...commonStyles.tableCol,
    width: "16%"
  }
};

export default styles;
